var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFarms(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1222_31824)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.504517 13.341C0.83888 13.2416 1.1469 13.0689 1.40618 12.8356C1.66546 12.6022 1.86951 12.314 2.00348 11.9919C2.20953 12.4726 2.56182 12.8762 3.01029 13.1453C3.45876 13.4144 3.98062 13.5353 4.50174 13.4909C5.02286 13.5353 5.54472 13.4144 5.9932 13.1453C6.44167 12.8762 6.79396 12.4726 7.00001 11.9919C7.20606 12.4726 7.55835 12.8762 8.00682 13.1453C8.4553 13.4144 8.97716 13.5353 9.49828 13.4909C10.0194 13.5353 10.5413 13.4144 10.9897 13.1453C11.4382 12.8762 11.7905 12.4726 11.9965 11.9919C12.1305 12.314 12.3346 12.6022 12.5938 12.8356C12.8531 13.0689 13.1611 13.2416 13.4955 13.341",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.504517 9.34386C1.17324 9.14502 1.73553 8.63896 2.00348 7.9948C2.42135 8.96966 3.50244 9.49376 4.50174 9.49376C6.50036 9.49376 7.99932 7.9948 7.99932 6.49584C7.99932 4.49723 7.00001 2.49861 4.50174 3.49792C4.66829 2.49861 5.70091 0.5 8.49897 0.5C11.297 0.5 12.9958 2.49861 13.4955 3.49792",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1222_31824"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFarms);
export default __webpack_public_path__ + "static/media/farms.865065192d07d2a4a7da89a1e1ded120.svg";
export { ForwardRef as ReactComponent };